/* ============================================================
   Extensiones Orgánicas: SEO overrides (generado por tools/generar_seo_overrides.py)
   Enlaces canónicos /products/ y /collections/ para todo lo que pinta el JS.
   ============================================================ */
"use strict";

(function () {
  var HANDLES = {
    "extensiones-de-clip-6-piezas-50cm-160g-1b-negro-natural": "extensiones-de-clip-lisas-50cm-negro-natural-1b",
    "extensiones-de-clip-6-piezas-50cm-160g-2-chocolate": "extensiones-de-clip-lisas-50cm-chocolate-2",
    "extensiones-de-clip-6-piezas-50cm-160g-4-castano-oscuro": "extensiones-de-clip-lisas-50cm-castano-oscuro-4",
    "extensiones-de-clip-6-piezas-50cm-160g-6-castano": "extensiones-de-clip-lisas-50cm-castano-6",
    "extensiones-de-clip-6-piezas-50cm-160g-22-rubio": "extensiones-de-clip-lisas-50cm-rubio-claro-22",
    "extensiones-de-clip-6-piezas-50cm-160g-26mix-mezcla-rubio-oscuro-y-claro": "extensiones-de-clip-lisas-50cm-mezcla-rubia-26mix",
    "extensiones-de-clip-6-piezas-50cm-160g-p4-613-mechado-chocolate-rubio": "extensiones-de-clip-lisas-50cm-chocolate-y-rubio-p4-613",
    "extensiones-de-clip-6-piezas-50cm-160g-p8-24-mechado-rubio-y-castano": "extensiones-de-clip-lisas-50cm-castano-y-rubio-p8-24",
    "extensiones-de-clip-6-piezas-50cm-160g-p18-613-mechado-rubio-claro-con-rubio-oscuro": "extensiones-de-clip-lisas-50cm-rubio-mechado-p18-613",
    "extensiones-de-clip-6-piezas-50cm-160g-sp18-613-rubio-oscuro-con-rubio-dorado": "extensiones-de-clip-lisas-50cm-rubio-dorado-mix-sp18-613",
    "extensiones-de-clip-6-piezas-50cm-160g-mt18-613-balayage-rubio-oscuro-rubio-claro": "extensiones-de-clip-lisas-50cm-balayage-rubio-mt18-613",
    "coleta-lisa-bloom-60cm-135g-1-negro": "coleta-postiza-lisa-bloom-60cm-negro-azabache-1",
    "coleta-lisa-bloom-60cm-135g-2-chocolate": "coleta-postiza-lisa-bloom-60cm-chocolate-2",
    "coleta-lisa-bloom-60cm-135g-4-castano-oscuro": "coleta-postiza-lisa-bloom-60cm-castano-oscuro-4",
    "coleta-lisa-bloom-60cm-135g-6-castano": "coleta-postiza-lisa-bloom-60cm-castano-6",
    "coleta-lisa-bloom-60cm-135g-8-castano-claro": "coleta-postiza-lisa-bloom-60cm-castano-claro-8",
    "coleta-lisa-bloom-60cm-135g-22-rubio-claro": "coleta-postiza-lisa-bloom-60cm-rubio-claro-22",
    "coleta-lisa-bloom-60cm-135g-26mix-mezcla-rubio-oscuro-y-claro": "coleta-postiza-lisa-bloom-60cm-mezcla-rubia-26mix",
    "coleta-lisa-bloom-60cm-135g-p8-24-mechado-rubio-y-castano": "coleta-postiza-lisa-bloom-60cm-castano-y-rubio-p8-24",
    "coleta-lisa-bloom-60cm-135g-p18-613-mechado-rubio-claro-con-rubio-oscuro": "coleta-postiza-lisa-bloom-60cm-rubio-mechado-p18-613",
    "coleta-lisa-bloom-60cm-135g-sp18-613-mechado-rubio-oscuro-rubio-dorado": "coleta-postiza-lisa-bloom-60cm-rubio-dorado-mix-sp18-613",
    "coleta-lisa-bloom-60cm-135g-mt18-613-balayage-rubio-oscuro-rubio-claro": "coleta-postiza-lisa-bloom-60cm-balayage-rubio-mt18-613",
    "coleta-lisa-bloom-60cm-135g-f4-30-613-mechado-chocolate-rubio-caoba-rubio-claro": "coleta-postiza-lisa-bloom-60cm-tricolor-caoba-f4-30-613",
    "coleta-lisa-bloom-60cm-135g-p4-613-mechado-chocolate-rubio-claro": "coleta-postiza-lisa-bloom-60cm-chocolate-y-rubio-p4-613",
    "coleta-lisa-bella-75cm-170g-1-negro": "coleta-postiza-larga-bella-75cm-negro-azabache-1",
    "coleta-lisa-bella-75cm-170g-2-chocolate": "coleta-postiza-larga-bella-75cm-chocolate-2",
    "coleta-lisa-bella-75cm-170g-4-castano-oscuro": "coleta-postiza-larga-bella-75cm-castano-oscuro-4",
    "coleta-lisa-bella-75cm-170g-6-castano": "coleta-postiza-larga-bella-75cm-castano-6",
    "coleta-lisa-bella-75cm-170g-8-castano-claro": "coleta-postiza-larga-bella-75cm-castano-claro-8",
    "coleta-lisa-bella-75cm-170g-22-rubio-claro": "coleta-postiza-larga-bella-75cm-rubio-claro-22",
    "coleta-lisa-bella-75cm-170g-26mix-mezcla-rubio-oscuro-rubio-claro": "coleta-postiza-larga-bella-75cm-mezcla-rubia-26mix",
    "coleta-lisa-bella-75cm-170g-p4-613-mechado-chocolate-rubio-claro": "coleta-postiza-larga-bella-75cm-chocolate-y-rubio-p4-613",
    "coleta-lisa-bella-75cm-170g-p8-24-mechado-rubio-y-castano": "coleta-postiza-larga-bella-75cm-castano-y-rubio-p8-24",
    "coleta-lisa-bella-75cm-170g-p18-613-mechado-rubio-claro-con-rubio-oscuro": "coleta-postiza-larga-bella-75cm-rubio-mechado-p18-613",
    "coleta-lisa-bella-75cm-170g-sp18-613-mechado-rubio-oscuro-rubio-dorado": "coleta-postiza-larga-bella-75cm-rubio-dorado-mix-sp18-613",
    "coleta-lisa-bella-75cm-170g-mt18-613-balayage-rubio-oscuro-rubio-claro": "coleta-postiza-larga-bella-75cm-balayage-rubio-mt18-613",
    "coleta-lisa-bella-75cm-170g-f4-30-613-mechado-chocolate-rubio-caoba-rubio-claro": "coleta-postiza-larga-bella-75cm-tricolor-caoba-f4-30-613",
    "coleta-ondulada-bianca-50cm-120g-1-negro": "coleta-postiza-ondulada-bianca-50cm-negro-azabache-1",
    "coleta-ondulada-bianca-50cm-120g-2-chocolate": "coleta-postiza-ondulada-bianca-50cm-chocolate-2",
    "coleta-ondulada-bianca-50cm-120g-4-castano-oscuro": "coleta-postiza-ondulada-bianca-50cm-castano-oscuro-4",
    "coleta-ondulada-bianca-50cm-120g-6-castano": "coleta-postiza-ondulada-bianca-50cm-castano-6",
    "coleta-ondulada-bianca-50cm-115g-8-castano-claro": "coleta-postiza-ondulada-bianca-50cm-castano-claro-8",
    "coleta-ondulada-bianca-50cm-120g-22-rubio-claro": "coleta-postiza-ondulada-bianca-50cm-rubio-claro-22",
    "coleta-ondulada-bianca-50cm-120g-26mix-mezcla-rubio-oscuro-y-claro": "coleta-postiza-ondulada-bianca-50cm-mezcla-rubia-26mix",
    "coleta-ondulada-bianca-50cm-120g-p4-613-mechado-chocolate-rubio-claro": "coleta-postiza-ondulada-bianca-50cm-chocolate-y-rubio-p4-613",
    "coleta-ondulada-bianca-50cm-120g-p8-24-mechado-rubio-y-castano": "coleta-postiza-ondulada-bianca-50cm-castano-y-rubio-p8-24",
    "coleta-ondulada-bianca-50cm-120g-p18-613-mechado-rubio-claro-con-rubio-oscuro": "coleta-postiza-ondulada-bianca-50cm-rubio-mechado-p18-613",
    "coleta-ondulada-bianca-50cm-120g-sp18-613-mechado-rubio-oscuro-rubio-dorado": "coleta-postiza-ondulada-bianca-50cm-rubio-dorado-mix-sp18-613",
    "coleta-ondulada-bianca-50cm-120g-mt18-613-balayage-rubio-oscuro-rubio-claro": "coleta-postiza-ondulada-bianca-50cm-balayage-rubio-mt18-613",
    "coleta-ondulada-bianca-50cm-120g-f4-30-613-mechado-chocolate-rubio-caoba-rubio-claro": "coleta-postiza-ondulada-bianca-50cm-tricolor-caoba-f4-30-613",
    "coleta-lila-1-negro": "coletero-mono-postizo-rizado-lila-negro-azabache-1",
    "coletero-lila-2-chocolate": "coletero-mono-postizo-rizado-lila-chocolate-2",
    "coletero-lila-4-castano-oscuro": "coletero-mono-postizo-rizado-lila-castano-oscuro-4",
    "coletero-lila-6-castano": "coletero-mono-postizo-rizado-lila-castano-6",
    "coletero-lila-8-castano-claro": "coletero-mono-postizo-rizado-lila-castano-claro-8",
    "coletero-lila-22-rubio-dorado": "coletero-mono-postizo-rizado-lila-rubio-claro-22",
    "coletero-lila-26mix-mechado-rubio-dorado-y-rubio-ceniza": "coletero-mono-postizo-rizado-lila-mezcla-rubia-26mix",
    "coletero-lila-p4-613-mechado-chocolate-y-rubio": "coletero-mono-postizo-rizado-lila-chocolate-y-rubio-p4-613",
    "coletero-lila-p8-24-mechado-castano-y-rubio-ceniza": "coletero-mono-postizo-rizado-lila-castano-y-rubio-p8-24",
    "coletero-lila-p18-613-mechado-rubio-dorado-y-rubio-claro": "coletero-mono-postizo-rizado-lila-rubio-mechado-p18-613",
    "coletero-lila-sp18-613-mechado-rubio-claro-y-rubio-ceniza": "coletero-mono-postizo-rizado-lila-rubio-dorado-mix-sp18-613",
    "coletero-lila-mt18613-mechado-rubio-oscuro-y-rubio-dorado": "coletero-mono-postizo-rizado-lila-balayage-rubio-mt18-613",
    "coletero-lila-f4-30-613-mechado-chocolate-rubio-dorado-rubio-medio-coaba": "coletero-mono-postizo-rizado-lila-tricolor-caoba-f4-30-613",
    "coletero-lola-1-negro": "coletero-mono-postizo-liso-lola-negro-azabache-1",
    "coletero-lola-2-chocolate": "coletero-mono-postizo-liso-lola-chocolate-2",
    "coletero-lola-4-castano-oscuro": "coletero-mono-postizo-liso-lola-castano-oscuro-4",
    "coletero-lola-6-castano": "coletero-mono-postizo-liso-lola-castano-6",
    "coletero-lola-8-castano-claro": "coletero-mono-postizo-liso-lola-castano-claro-8",
    "coletero-lola-22-rubio-dorado": "coletero-mono-postizo-liso-lola-rubio-claro-22",
    "coletero-lola-26-mechado-rubio-dorado-y-rubio-ceniza": "coletero-mono-postizo-liso-lola-mezcla-rubia-26mix",
    "coletero-lola-p4-613-mechado-castano-oscuro-y-rubio-claro": "coletero-mono-postizo-liso-lola-chocolate-y-rubio-p4-613",
    "coletero-lola-p8-24-mechado-castano-y-rubio-ceniza": "coletero-mono-postizo-liso-lola-castano-y-rubio-p8-24",
    "coletero-lola-p18-613-mechado-rubio-dorado-y-rubio-ceniza": "coletero-mono-postizo-liso-lola-rubio-mechado-p18-613",
    "coletero-lola-sp18-613-mechado-rubio-oscuro-y-rubio-ceniza": "coletero-mono-postizo-liso-lola-rubio-dorado-mix-sp18-613",
    "coletero-lola-mt18-613-mechado-rubio-claro-y-rubio-ceniza": "coletero-mono-postizo-liso-lola-balayage-rubio-mt18-613",
    "coletero-lola-f4-30-613-mechado-chocolate-rubio-claro-rubio-medio-caoba": "coletero-mono-postizo-liso-lola-tricolor-caoba-f4-30-613"
};
  (window.CATALOG || CATALOG).forEach(function (line) {
    line.colors.forEach(function (c) { if (HANDLES[c[3]]) c[3] = HANDLES[c[3]]; });
  });
})();

var EO_COLLECTION_URL = {
  clip: "/collections/extensiones-de-clip",
  coletas: "/collections/coletas-postizas",
  coleteros: "/collections/coleteros-de-pelo"
};
var EO_PAGE_URL = {
  "/pages/colores": "/pages/carta-de-colores",
  "/pages/fibra": "/pages/nuestra-fibra",
  "/pages/contacto#faq": "/pages/preguntas-frecuentes",
  "/pages/contacto#envios": "/pages/envios-y-devoluciones"
};

function eoProductUrl(lineId, code) {
  var line = getLine(lineId);
  if (!line) return "/collections/all";
  return "/products/" + getColor(line, code).handle;
}

function eoCanonical(href) {
  var u;
  try { u = new URL(href, location.origin); } catch (e) { return null; }
  if (u.origin !== location.origin) return null;
  if (u.pathname === "/pages/producto") return eoProductUrl(u.searchParams.get("p"), u.searchParams.get("color"));
  if (u.pathname === "/pages/coleccion") return EO_COLLECTION_URL[u.searchParams.get("c")] || "/collections/all";
  var key = u.pathname + u.hash;
  return EO_PAGE_URL[key] || EO_PAGE_URL[u.pathname] || null;
}

function eoRewriteLinks(root) {
  (root || document).querySelectorAll("a[href]").forEach(function (a) {
    var next = eoCanonical(a.getAttribute("href"));
    if (next) a.setAttribute("href", next);
  });
}

/* Same card as main.js, linking to the canonical product URL. */
function productCard(line, opts) {
  opts = opts || {};
  var c0 = line.colors[0];
  var url = "/products/" + c0[3];
  var useCard = opts.useCardImg && line.cardImg;
  var img1 = EOURL(useCard ? line.cardImg : line.imgDir + "/" + c0[1]);
  var fitCls = !useCard && line.imgFit === "contain" ? " fit-contain" : "";
  var dots = line.colors.slice(0, 5).map(function (c) {
    return '<span class="chip-dot" style="background:' + COLOR_INFO[c[0]].hex + '"></span>';
  }).join("");
  var more = line.colors.length > 5 ? '<span class="more">+' + (line.colors.length - 5) + "</span>" : "";
  return '<article class="pcard reveal" style="--d:' + (opts.delay || 0) + 's">' +
    '<div class="ph-wrap">' +
    '<a class="ph' + fitCls + '" href="' + url + '" aria-label="' + esc(line.name) + '">' +
    '<span class="badge">' + esc(line.badge) + "</span>" +
    '<img class="main" src="' + img1 + '" alt="' + esc(line.name) + ": " + esc(line.tagline) + '" loading="lazy" width="600" height="750">' +
    "</a>" +
    '<button class="quick" data-qv="' + line.id + '" aria-label="Vista rápida de ' + esc(line.name) + '">' + ICONS.eye + "</button>" +
    "</div>" +
    '<div class="body"><h3><a href="' + url + '">' + esc(line.name) + "</a></h3>" +
    '<span class="sub">' + esc(line.subtitle) + "</span>" +
    '<div class="price-row"><span class="price">' + fmtPrice(line.price) + "</span>" +
    '<span class="chips">' + dots + more + "</span></div>" +
    (opts.cta ? '<a class="btn btn-primary pcard-cta" href="' + url + '">Ver producto</a>' : "") +
    "</div>" +
    "</article>";
}

/* Catalog copy: material wording agreed on 26-10-2026 ("fibra con aspecto natural"). */
(function () {
  function fix(t) {
    return typeof t === "string"
      ? t.replace(/fibra orgánica premium/g, "fibra premium con aspecto natural").replace(/fibra orgánica/g, "fibra con aspecto natural")
      : t;
  }
  /* Sin puntos medios (26-10-2026): "Coleta Lisa \u00b7 Bloom" pasa a "Coleta Lisa Bloom" y
     "Lisa \u00b7 60 cm \u00b7 135 g" a "Lisa, 60 cm, 135 g". */
  function sinPuntos(t, sep) {
    return typeof t === "string" ? t.replace(/\s*\u00b7\s*/g, sep) : t;
  }
  (window.CATALOG || CATALOG).forEach(function (line) {
    line.name = sinPuntos(line.name, " ");
    Object.keys(line).forEach(function (k) {
      if (k !== "name" && typeof line[k] === "string") line[k] = sinPuntos(line[k], ", ");
    });
    line.subtitle = fix(line.subtitle);
    line.tagline = fix(line.tagline);
    line.description = fix(line.description);
  });
})();

/* ============================================================
   Forms. The original theme only showed a toast and sent nothing.
   Lead forms (mayoristas, afiliadas, contacto) become Shopify contact
   forms, emailed to the store; newsletter forms become customer forms
   (subscribed customer + tag). Both submit natively, so Shopify's
   spam challenge still works. These replace main.js's versions.
   ============================================================ */
function eoHidden(form, name, value) {
  var input = document.createElement("input");
  input.type = "hidden";
  input.name = name;
  input.value = value;
  form.appendChild(input);
}

function eoAsShopifyForm(form, id, formType) {
  form.id = id;
  form.method = "post";
  form.action = "/contact#" + id;
  form.setAttribute("accept-charset", "UTF-8");
  eoHidden(form, "form_type", formType);
  eoHidden(form, "utf8", "✓");
}

function eoPostedFlag(name) {
  return new URLSearchParams(location.search).get(name) === "true";
}

function eoClearPostedFlag() {
  var url = new URL(location.href);
  url.searchParams.delete("contact_posted");
  url.searchParams.delete("customer_posted");
  url.searchParams.delete("form_type");
  history.replaceState(null, "", url.pathname + url.search + url.hash);
}

function initLeadForms() {
  var messages = {};
  $$("form[data-lead]").forEach(function (f, i) {
    var id = "eo-contacto-" + i;
    messages["#" + id] = f.dataset.lead;
    f.removeAttribute("data-lead");
    eoAsShopifyForm(f, id, "contact");
    eoHidden(f, "contact[Formulario]", location.pathname);
    $$("input[name], select[name], textarea[name]", f).forEach(function (el) {
      if (el.type === "hidden") return;
      if (el.name === "email") el.name = "contact[email]";
      else if (el.name === "message") el.name = "contact[body]";
      else {
        var label = el.id && f.querySelector('label[for="' + el.id + '"]');
        el.name = "contact[" + (label ? label.textContent.trim() : el.name) + "]";
      }
    });
  });
  if (eoPostedFlag("contact_posted")) {
    var keys = Object.keys(messages);
    toast(messages[location.hash] || (keys.length ? messages[keys[0]] : "Mensaje enviado. Te responderemos pronto."));
    eoClearPostedFlag();
  }
}

function initNewsletter() {
  $$("form[data-newsletter]").forEach(function (f, i) {
    f.removeAttribute("data-newsletter");
    eoAsShopifyForm(f, "eo-newsletter-" + i, "customer");
    eoHidden(f, "contact[tags]", location.pathname.indexOf("fidelidad") > -1 ? "newsletter, circulo-organica" : "newsletter");
    var email = f.querySelector("input[type=email]");
    if (email) email.name = "contact[email]";
  });
  if (eoPostedFlag("customer_posted")) {
    toast("Gracias, ya estás en la lista. Revisa tu correo.");
    eoClearPostedFlag();
  }
}

/* Envío gratis en 24 h a la península sin mínimo (26-10-2026): la barra de la cesta
   ya no cuenta hasta 50 € (FREE_SHIPPING_THRESHOLD es una constante de catalog.js). */
var EO_FREEBAR = "<b>Env\u00edo gratis</b> en 24 h a la Espa\u00f1a peninsular.";
function eoFreebar() {
  var fb = document.getElementById("freebar");
  if (!fb || !fb.innerHTML || fb.innerHTML === EO_FREEBAR) return;
  fb.innerHTML = EO_FREEBAR;
}

document.addEventListener("DOMContentLoaded", function () {
  eoRewriteLinks(document);
  eoFreebar();
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) { if (n.nodeType === 1) eoRewriteLinks(n); });
    });
    eoFreebar();
  }).observe(document.body, { childList: true, subtree: true });
});
